<template>
  <div class="login-container" :style="{ backgroundImage: `url(${reffWallpaper})` }">
    <!-- Flash message -->
    <transition name="fade">
      <v-alert v-if="flashMessage" class="flash-message" :type="flashType" border="right" colored-border elevation="2"
        dense dark>
        {{ flashMessage }}
      </v-alert>
    </transition>

    <v-container class="d-flex align-center justify-center" style="min-height: 100vh">
      <v-card class="login-card d-flex" elevation="12">
        <v-row no-gutters class="flex-grow-1">

          <v-col cols="12" md="6" class="left-col d-none d-md-flex flex-column align-center justify-center px-6">

            <div class="text-wrapper text-center mb-4">
              <br />
              <h2 style="
                  font-weight: 600;
                  color: #2c3e50;
                  font-size: 32px;
                  margin-bottom: 10px;
                ">
                Welcome
              </h2>
              <p style="font-size: 16px; color: #555; line-height: 1.6">

                <strong style="color: #000000">To Integrated Bonded Zone ERP System</strong>
              </p>
            </div>


            <div class="logo-wrapper">
              <v-img :src="reffLogo" contain height="190" max-width="350" class="mx-auto"></v-img>
            </div>
          </v-col>

          <v-col cols="12" md="6" class="right-col d-flex flex-column justify-center">
            <v-card-text>
              <div class="text-center mb-4 text-h6 font-weight-bold">
                {{ companyName }}
              </div>
              <form @submit.prevent="login">
                <v-text-field v-model="username" label="Username" prepend-inner-icon="mdi-account" outlined dense
                  required />
                <v-text-field v-model="password" :type="showPassword ? 'text' : 'password'" label="Password"
                  prepend-inner-icon="mdi-lock" :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword" outlined dense required />
                <v-checkbox v-model="rememberMe" label="Remember Me" dense />
                <v-btn color="primary" type="submit" block class="mt-3" :loading="loading"
                  @click="autoSubmitIfRememberMe">
                  Login
                </v-btn>
              </form>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      companyName: process.env.VUE_APP_COMPANY_NAME,
      username: "",
      password: "",
      flashMessage: "",
      flashType: "",
      token: "",
      reffLogo: "",
      reffWallpaper: "",
      loading: false,
      rememberMe: false,
      showPassword: false,
    };
  },
  created() {
    this.getRefLogo();
    this.getRefWallpaper();
    const token = localStorage.getItem("token");
    const rememberMeUsername = localStorage.getItem("rememberMeUsername");
    const rememberMePassword = localStorage.getItem("rememberMePassword");
    if (token) {
      this.token = token;
    }
    if (rememberMeUsername && rememberMePassword) {
      this.username = rememberMeUsername;
      this.password = rememberMePassword;
      this.rememberMe = true;
    }
  },
  methods: {
    async login() {
      this.loading = true;
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.post(`${apiUrl}/auth/login`, {
          username: this.username,
          password: this.password,
        });

        const { token, username, username_ceisa, id, timer, roles, lap_type } =
          response.data;

        localStorage.setItem("token", token);
        localStorage.setItem("username", username);
        localStorage.setItem("username_ceisa", username_ceisa);
        localStorage.setItem("id", id);
        localStorage.setItem("timer", timer);
        localStorage.setItem("roles", roles);
        localStorage.setItem("lap_type", lap_type);

        if (this.rememberMe) {
          localStorage.setItem("rememberMeUsername", this.username);
          localStorage.setItem("rememberMePassword", this.password);
        }

        localStorage.setItem("flashMessage", `Welcome, ${username}!`);
        localStorage.setItem("justLoggedIn", true);

        this.$router.push({ name: "home" });
        window.location.reload();
      } catch (error) {
        this.flashType = "error";
        this.flashMessage = "Incorrect username or password.";
        this.loading = false;
        setTimeout(() => (this.flashMessage = null), 3000);
      }
    },
    autoSubmitIfRememberMe() {
      if (this.rememberMe && this.username && this.password) {
        this.login();
      }
    },
    getRefLogo() {
      const data = process.env.VUE_APP_COMPANY_LOGO;
      if (data) {
        this.reffLogo = require(`@/assets/images/${data}.png`);
      } else {
        this.reffLogo = require("@/assets/images/login.png");
      }
    },
    getRefWallpaper() {
      const data = process.env.VUE_APP_COMPANY_WALLPAPER;
      if (data) {
        this.reffWallpaper = require(`@/assets/images/${data}.jpg`);
      } else {
        this.reffWallpaper = require("@/assets/images/sintact.jpg");
      }
    }
  },
};
</script>
<style scoped>
.login-container {
  /* background-image: var(--bg-image); */
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}

.login-card {
  max-width: 850px;
  width: 100%;
  height: 450px;
  border-radius: 16px;
  overflow: hidden;
  /* backdrop-filter: blur(8px); */
  background-color: rgba(255, 255, 255, 0.692);
  /* glass effect */
  backdrop-filter: blur(20px);
}

.left-col {
  /* background-color: rgba(255, 255, 255, 0.692); glass effect */
  /* backdrop-filter: blur(20px); */
  padding: 24px;
}

.right-col {
  /* background-color: rgba(255, 255, 255, 0.7); */
  padding: 32px;
}

.transparent-bg {
  background-color: transparent !important;
}

.flash-message {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
}
</style>
